import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

export function SwitchWithLabel({ onChange, label, nameAndId, checked = false, className = null }) {
    return (
        <FormGroup className={className}>
            <FormControlLabel name={nameAndId} control={<Switch onChange={onChange} />} checked={checked} label={label} />
        </FormGroup>
    );
}